export const getHeights = (
  filteredStores: any[],
  isAdminUser: boolean,
  isShadowUser: boolean,
  openedFromModal: boolean,
): number => {
  const filteredStoreCount = filteredStores?.length || 0;
  const rowHeight = isAdminUser && !isShadowUser ? 89 : 60;
  const maxHeights = openedFromModal ? 420 : 730;
  const maxRows = openedFromModal ? 5 : 8;

  return filteredStoreCount > maxRows ? maxHeights : filteredStoreCount * rowHeight;
};
